import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { FuseSharedModule } from '@fuse/shared.module';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { TranslateModule } from '@ngx-translate/core';
import { FuseWidgetModule } from '@fuse/components';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../profile/profile.service';
import { ProfilehelperDD } from '../../../shared/common/helper/personaldetails-helper';
import { ToastrService } from 'ngx-toastr';
import { AgGridModule } from 'ag-grid-angular/main';
import { ProfileViewComponent } from './profile-view.component';
import { ProfileModule } from '../profile/profile.module';

const routes = [
    { path: '', redirectTo: 'profile', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'profile-view', component: ProfileViewComponent, canActivate: [AuthGuardService] }
];

@NgModule({
    declarations: [ProfileViewComponent],
    imports: [
        RouterModule.forChild(routes),
        AgGridModule.withComponents([]),
        TranslateModule,
        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTableModule,
        MatTabsModule,
        FuseSharedModule,
        FuseWidgetModule,
        MatDividerModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        NgbModule,
        ProfileModule
    ],
    providers: [
        ProfileService,
        AuthGuardService,
        ProfilehelperDD,
        ToastrService
    ]
})
export class ProfileViewModule { }